const firebaseConfig = {
  apiKey: "AIzaSyDQwdZuTmOiQy5K33P048HHYBzJg6l1kIw",
  authDomain: "crs-info.firebaseapp.com",
  databaseURL: "https://crs-info.firebaseio.com",
  projectId: "crs-info",
  storageBucket: "crs-info.appspot.com",
  messagingSenderId: "970178796646",
  appId: "1:970178796646:web:eec8f0568a6be0adb561a7",
  measurementId: "G-RLXPLD3CTT"
};

export default firebaseConfig;
